var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('img',{staticClass:"img",attrs:{"src":_vm.orderError}}),_c('p',{staticClass:"error-title"},[_vm._v("订单创建失败")]),_c('p',{staticClass:"error-tips"},[_vm._v("请联系班主任下单")])])}
var staticRenderFns = []

export { render, staticRenderFns }